// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert-alert-e4rpV","danger":"Alert-danger--w79e","info":"Alert-info-1J8mE","success":"Alert-success-1KaBO","warning":"Alert-warning-aVFPJ"};